import React, {useEffect, useState} from 'react';
import {BrowserRouter, Redirect, Route, Switch} from 'react-router-dom';
import {Information, DocsExtract, QrCodeScanner} from '../containers';
import {DeviceContext} from '../context';
import {
    DEVICE_TYPE_DESKTOP,
    DEVICE_TYPE_MOBILE,
    DEVICE_TYPE_PAD,
    ROUTE_DOCS_EXTRACT_ID,
    ROUTE_INFORMATION,
    ROUTE_QR_CODE_SCANER,
} from '../constants';

import './app.scss';

function App() {
    const [deviceType, setDeviceType] = useState(DEVICE_TYPE_MOBILE);

    useEffect(() => {
        function resize() {
            let type;
            if (window.innerWidth <= 768) {
                type = DEVICE_TYPE_MOBILE;
            } else if (window.innerWidth <= 1024) {
                type = DEVICE_TYPE_PAD;
            } else {
                type = DEVICE_TYPE_DESKTOP;
            }
            setDeviceType(type);
        }

        resize();
        window.addEventListener('resize', resize);
    }, []);

    return (
        <BrowserRouter>
            <DeviceContext.Provider value={deviceType}>
                <div className="app">
                    <Switch>
                        <Route exact path={ROUTE_INFORMATION} component={Information}/>
                        <Route exact path={ROUTE_DOCS_EXTRACT_ID} component={DocsExtract}/>
                        <Route exact path={ROUTE_QR_CODE_SCANER} component={QrCodeScanner}/>
                        <Redirect to={ROUTE_INFORMATION}/>
                    </Switch>
                </div>
            </DeviceContext.Provider>
        </BrowserRouter>
    );
}

export default App;
